import React from "react";
import { Row, Col, Modal, Button, notification } from "antd";
import styles from "./GroceryModals.module.scss";
import textStyles from "../../Shared/Styles/TextStyles.module.scss";
import { deleteTempGroceryCart } from "../../../services/GroceryService";
import { useGroceryCtx } from "../../../context/GroceryContext";
import { CartDeleteAction } from "../../../types/GroceryTypes";

type Props = {
  isVisible: boolean;
  setVisibility: Function;
  serviceUserPersonId: number;
  handleDrawerClose: Function;
};

function EmptyShoppingCartModal({
  isVisible,
  setVisibility,
  serviceUserPersonId,
  handleDrawerClose,
}: Props) {
  const { cachedGroceryCartItemsCtx } = useGroceryCtx();
  const [, setCachedGroceryCartItems] = cachedGroceryCartItemsCtx;

  async function handleDeleteTempCartDetails() {
    setVisibility(false);
    try {
      await deleteTempGroceryCart(
        serviceUserPersonId,
        CartDeleteAction.EmptyCartItems
      );
      setCachedGroceryCartItems([]);
      handleDrawerClose();
    } catch {
      notification.error({
        message: "Failed to delete items in the cart.",
      });
    }
  }

  return (
    <Modal
      visible={isVisible}
      className={styles.emptyCartModalContainer}
      centered
      footer={
        <Row className={styles.cartModalBtnsAlignment} gutter={[8, 8]}>
          <Col className={styles.btnFlex1}>
            <Button
              className={`${styles.cancelBtn} ${textStyles.normalText14} `}
              onClick={() => setVisibility(false)}
            >
              Cancel
            </Button>
          </Col>
          <Col className={styles.btnFlex1}>
            <Button
              className={`${styles.continueBtn} ${styles.emptyCartEmptyBtn} `}
              onClick={handleDeleteTempCartDetails}
            >
              Empty
            </Button>
          </Col>
        </Row>
      }
    >
      <Row className={`${textStyles.boldText16} ${styles.marginDown8}`}>
        Empty your cart?
      </Row>

      <Row className={textStyles.normalText14}>
        This will remove all item from your cart.
      </Row>
    </Modal>
  );
}

export default EmptyShoppingCartModal;
